export function getOverallFileSize(files: File[]) {
    return files.reduce((previousValue, currentValue) => previousValue + currentValue.size, 0);
}
